import { isValidUuid } from "./uuid";

const readProjectIdCandidate = (candidate) => {
  if (!candidate) return "";
  if (isValidUuid(String(candidate))) return String(candidate);
  return "";
};

export const extractProjectId = (payload) => {
  if (!payload || typeof payload !== "object") return "";
  return (
    readProjectIdCandidate(payload.projectId) ||
    readProjectIdCandidate(payload.project_id) ||
    readProjectIdCandidate(payload.projectUuid) ||
    readProjectIdCandidate(payload.projectUUID) ||
    readProjectIdCandidate(payload?.project?.id) ||
    ""
  );
};

export const extractProjectIdFromProperty = (property) => {
  if (!property || typeof property !== "object") return "";
  return (
    readProjectIdCandidate(property.projectId) ||
    readProjectIdCandidate(property.project_id) ||
    readProjectIdCandidate(property?.project?.id) ||
    readProjectIdCandidate(property?.data?.projectId) ||
    readProjectIdCandidate(property?.data?.project_id) ||
    readProjectIdCandidate(property?.data?.project?.id) ||
    ""
  );
};

export const getStoredProjectId = () => {
  try {
    const stored = localStorage.getItem("myv_selected_project_id") || "";
    return readProjectIdCandidate(stored);
  } catch (error) {
    return "";
  }
};

export const persistProjectId = (projectId) => {
  const nextId = readProjectIdCandidate(projectId);
  if (!nextId) return false;
  try {
    localStorage.setItem("myv_selected_project_id", nextId);
    return true;
  } catch (error) {
    return false;
  }
};

export const clearStoredProjectId = () => {
  try {
    localStorage.removeItem("myv_selected_project_id");
  } catch (error) {
    // no-op
  }
};